// ---------------------------------------------- modules import
import React, { ChangeEvent, FormEvent, FunctionComponent } from "react";
import { Redirect } from "react-router-dom";

import { useAuth } from "./hooks";
import { ThemeContext } from "../../contexts/themeContext";
import { pattern } from "../../store/helpers/validationHelper";

// ---------------------------------------------- the component
const Login: FunctionComponent = () => {
  // ---------------------------------------------- local state
  const {
    error,
    areLoaded,
    isEmptied,
    isAuthValid,
    onChange,
    onLogin
  } = useAuth();

  // ---------------------------------------------- handlers
  const handleChange = (e: ChangeEvent<HTMLInputElement>) =>
    onChange(e.currentTarget.id, e.currentTarget.value);

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    onLogin();
  };

  // ---------------------------------------------- content
  return isEmptied ? (
    <ThemeContext.Consumer>
      {({ theme }) => (
        <div className="container" style={{ marginTop: "90px" }}>
          <div className="row" style={{ marginBottom: "0px" }}>
            <div className="col s6 m4 l2 offset-s3 offset-m4 offset-l5">
              <img
                src="images/labbaik-logo.png"
                alt="labbaik-logo"
                className="circle responsive-img"
              />
            </div>
          </div>

          <div className="row">
            <form
              className="col s8 m6 offset-s2 offset-m3"
              onSubmit={handleSubmit}
            >
              <div className="input-field">
                <input
                  type="text"
                  id="email"
                  className="validate"
                  pattern={pattern.login.email.toString().slice(1, -1)}
                  onChange={handleChange}
                  required
                />

                <label htmlFor="email">Your email</label>
              </div>

              <div className="input-field">
                <input
                  type="password"
                  id="password"
                  className="validate"
                  pattern={pattern.login.password.toString().slice(1, -1)}
                  onChange={handleChange}
                  required
                />

                <label htmlFor="password">Password</label>
              </div>

              <div className="input-field center">
                <button
                  type="submit"
                  className={`btn waves-effect waves-teal ${
                    isAuthValid() ? "" : "disabled"
                  }`}
                  style={{ backgroundColor: theme.ui, color: theme.syntax }}
                >
                  Login
                </button>
              </div>

              <div className="input-field center" style={{ color: theme.text }}>
                {!areLoaded ? (
                  <p>authenticating ...</p>
                ) : error ? (
                  <p className="red-text text-darken-3">{error}</p>
                ) : null}
              </div>
            </form>
          </div>
        </div>
      )}
    </ThemeContext.Consumer>
  ) : (
    <Redirect to="/" />
  );
};

export default Login;
